import React from 'react';
import { Link } from 'react-router-dom';
import './PurpleWhiteButton.css';

const PurpleWhiteButton = ({ to, text }) => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Link to={to} className="pwb-button" onClick={handleClick}>
      {text}
    </Link>
  );
};

export default PurpleWhiteButton;
